<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <MergeDataForm
        ref="mergeDataForm"
        v-model="mergeDataFormModel"
        label-width="10em"
        formMode="register"
        billingYmMode="this"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import MergeDataForm from '@/components/organisms/dialog/data/MergeDataForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    MergeDataForm,
    RegisterDialogFooter
  },
  mixins: [
    CustomerAutocompleteLoader,
    RegistrationSymbolAutocompleteLoader,
    AirportAutocompleteLoader
  ],
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => ({})
    },
    visible: Boolean
  },
  data () {
    return {
      mergeDataFormModel: {
        billing_ym: undefined,
        registration_symbol: undefined,
        action_type: undefined,
        action_time: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        callsign: undefined,
        route_code: undefined,
        operator_code: undefined,
        bill_to_code: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        flight_purpose_code: undefined,
        flight_type: undefined,
        irregular: undefined,
        billing_exclusion_flag: undefined,
        use_data_status: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.mergeDataForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()
      this.$refs.mergeDataForm.validate()
        .then((valid) => {  // eslint-disable-line
          return this.$axios.post('/merge-data', this.mergeDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.mergeDataFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'model_code', 'operator_code', 'bill_to_code', 'departure_airport_code', 'destination_airport_code', 'irregular']
      this.$nextTick(() => {
        this.$refs.mergeDataForm.clearFields()
        if (Object.keys(this.currentRow).length === 0) {
          Object.keys(this.mergeDataFormModel)
            .forEach((x) => {
              this.$set(this.mergeDataFormModel, x, undefined)
            })
        } else {
          Object.keys(this.mergeDataFormModel)
            .forEach((x) => {
              if (trimItem.includes(x) && this.currentRow[x]) {
                this.currentRow[x] = this.currentRow[x].trimEnd()
              }
              if (this.currentRow[x] !== undefined) {
                this.$set(this.mergeDataFormModel, x, this.currentRow[x])
              }
            })
        }
        this.$set(this.mergeDataFormModel, 'billing_ym', this.getDefaultBillingYm())
      })
    }
  }
}
</script>

<style lang="scss">
</style>
